<template>
  <v-card
    outlined
    @click="$router.push({ name: 'show_building', params: { id: building.id } })"
    >
    <v-card-text
      class="d-flex flex-row align-center justify-space-between"
      >
      <div>
        {{ building.fullAddress }}
      </div>

      <delete
        @reload="$emit('reload')"
        :building="building"
        ></delete>
    </v-card-text>
  </v-card>
</template>

<script>
import Delete from './Delete'

export default {
  props: {
    building: {
      required: true,
      type: Object
    }
  },

  components: {
    Delete
  }
}
</script>
